import { Grid } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { Outlet, useLocation } from "react-router-dom"
import { SERVICE_CENTER_ADMIN_ROUTE, SERVICE_CENTER_REPORTS_ROUTE, USER_REPORTS_ROUTE } from "../../constants/routes"
import { PollingPauseProvider } from "../../core/api/PollingPauseProvider"
import { CreateOrderDialogHost } from "../components/createOrder/CreateOrderDialogHost"
import { useOrderDialogUrlState } from "../components/createOrder/hooks/useOrderDialogUrlState"
import { tailwindPalette } from "../../modules/theme/tailwindPalette"
import { WellknownHeight } from "../../constants/wellknown"
import { Footer } from "./Footer"
import { whenPrintingPlainBackground } from "../components/print/printPageOnly"

const useStyles = makeStyles()((theme) => ({
    page: {
        // NOTE: We need the div to expand with the content in the x-direction
        // instead of default behavior of overflowing, since the background will
        // otherwise not fill the whole page
        width: "fit-content",
        // NOTE: We need to force the div to take up minimum 100% of parent when
        // using fit-content
        minWidth: "100%",
        // phones: unshrinkable content must not widen the top and bottom bars past the screen
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },

        height: "100%",
        minHeight: "100vh",
    },
    defaultBackground: {
        backgroundColor: theme.palette.tailwind.slate[50],
    },
    alternativeBackground: {
        backgroundColor: tailwindPalette.blue[50],
        ...whenPrintingPlainBackground({
            backgroundColor: theme.palette.common.white,
        }),
    },
    container: {
        height: `calc(100% - ${WellknownHeight.PRIMARY_TOP_BAR}px)`,
    },
    contentGrid: {
        height: "100%",
    },
}))

export function Layout() {
    const { classes, cx } = useStyles()
    const location = useLocation()
    const { isOpen: isOrderDialogOpen } = useOrderDialogUrlState()

    // Can be expanded for other pages
    const alternativeBgRoutes = [USER_REPORTS_ROUTE, SERVICE_CENTER_REPORTS_ROUTE, SERVICE_CENTER_ADMIN_ROUTE]
    const isAlternativeBg = alternativeBgRoutes.some((route) => location.pathname.startsWith(route))

    return (
        <div
            className={cx(classes.page, {
                [classes.defaultBackground]: !isAlternativeBg,
                [classes.alternativeBackground]: isAlternativeBg,
            })}
        >
            <Grid
                container
                direction="column"
                wrap="nowrap"
                justifyContent="space-between"
                className={classes.contentGrid}
            >
                <Grid item>
                    <PollingPauseProvider paused={isOrderDialogOpen}>
                        <Outlet />
                    </PollingPauseProvider>
                </Grid>
                <Footer />
                <CreateOrderDialogHost />
            </Grid>
        </div>
    )
}
